import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import DashboardWrapper from "../../components/DashboardWrapper";
import CrudTable from "../../components/dashboard/table/CrudTable";
import CrudForm from "../../components/dashboard/form/CrudForm";
import { useCrud } from "../../hooks/useCrud";
import Swal from "sweetalert2";
import authService from "../../services/authService";
const generateSlug = (text) =>
  text.toString().toLowerCase().trim().replace(/\s+/g, "-");

export default function SubCategory() {
  const navigate = useNavigate();
const [searchText, setSearchText] = useState("");
  const {
    data: subCategories = [],
    loading: subLoading,
    errors: subErrors,
    createItem,
    updateItem,
    deleteItem,
  } = useCrud(`${process.env.REACT_APP_API_URL}/backend/sub-categories`);

  const {
    data: categories = [],
    loading: catLoading,
    errors: catErrors,
  } = useCrud(`${process.env.REACT_APP_API_URL}/backend/categories`);

  const [editingItem, setEditingItem] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
const allowedFields = useMemo(
  () => [
    "category_id",
    "name",
    "sub_cat_image",
    "status",
    "seo_title",
    "seo_description",
    "seo_keywords",
    "description",
  ],
  []
);

  //   useEffect(() => {
  //     if (subErrors.auth || subErrors.fetch?.includes("Unauthorized") || catErrors.auth || catErrors.fetch?.includes("Unauthorized")) {
  //       Swal.fire("Session Expired", "Please log in again.", "error");
  //       navigate("/login");
  //     }
  //   }, [subErrors, catErrors, navigate]);

 const getFormData = useCallback(
  (item) => {
    if (!item) {
      return {
        category_id: "",
        name: "",
        sub_cat_image: null, // IMPORTANT: makes the image field appear
        status: 1,
        seo_title: "",
        seo_description: "",
        seo_keywords: "",
        description: "",
      };
    }

    return allowedFields.reduce((acc, field) => {
      acc[field] =
        field === "status"
          ? Number(item[field] ?? 1)
          : item[field] ?? (field === "sub_cat_image" ? null : "");

      return acc;
    }, {});
  },
  [allowedFields]
);

  const hasDuplicate = useCallback(
    (name, slug, id = null) =>
      subCategories.some(
        (item) =>
          (item.name.toLowerCase() === name.toLowerCase() ||
            item.slug.toLowerCase() === slug.toLowerCase()) &&
          item.id !== id
      ),
    [subCategories]
  );

const showSwal = useCallback((title, text, icon) => {
  Swal.fire({
    title,
    text,
    icon,
    confirmButtonText: "OK",
    confirmButtonColor: "#214b7a", // 🔵 blue hex color
  });
}, []);


const handleSubmit = useCallback(
  async (formData) => {
    const name = String(formData.name || "").trim();
    const categoryId = Number(formData.category_id);

    if (!name) {
      showSwal("Error!", "Sub-category name is required.", "warning");
      return;
    }

    if (!Number.isInteger(categoryId) || categoryId <= 0) {
      showSwal("Error!", "Please select a valid category.", "warning");
      return;
    }

    const slug = generateSlug(name);

    if (hasDuplicate(name, slug, editingItem?.id)) {
      showSwal(
        "Duplicate Found!",
        "A sub-category with the same name or slug already exists.",
        "warning"
      );
      return;
    }

    // Send multipart/form-data instead of a JSON object.
    const payload = new FormData();

    payload.append("category_id", String(categoryId));
    payload.append("name", name);
    payload.append("slug", slug);
    payload.append("status", String(Number(formData.status ?? 1)));
    payload.append("seo_title", formData.seo_title || "");
    payload.append("seo_description", formData.seo_description || "");
    payload.append("seo_keywords", formData.seo_keywords || "");
    payload.append("description", formData.description || "");

    // Upload only when a new image file has been selected.
    if (formData.sub_cat_image instanceof File) {
      payload.append("sub_cat_image", formData.sub_cat_image);
    }

  const token = authService.getToken();

console.log("Auth token exists:", Boolean(token));
console.log("Auth token length:", token?.length || 0);

if (!token) {
  await Swal.fire({
    title: "Login Required",
    text: "Your authToken is missing. Please log in again.",
    icon: "warning",
    confirmButtonColor: "#214b7a",
  });

  navigate("/login");
  return;
}

    const baseUrl = process.env.REACT_APP_API_URL.replace(/\/+$/, "");
    const url = editingItem
      ? `${baseUrl}/backend/sub-categories/${editingItem.id}`
      : `${baseUrl}/backend/sub-categories`;

    try {
      console.log("API URL:", url);
      console.log("FormData fields:");

      for (const [key, value] of payload.entries()) {
        console.log(
          key,
          value instanceof File
            ? { name: value.name, type: value.type, size: value.size }
            : value
        );
      }

      const response = await fetch(url, {
        method: editingItem ? "PUT" : "POST",
        headers: {
          Accept: "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: payload,
      });

      const result = await response.json();

      if (!response.ok) {
        console.error("API error response:", result);
        throw new Error(
          result.detail?.[0]?.msg ||
            result.message ||
            `Request failed with status ${response.status}`
        );
      }

      console.log("API success:", result);

    
await Swal.fire({
  title: editingItem ? "Updated!" : "Created!",
  text:
    result.message ||
    (editingItem
      ? "Sub-category updated successfully."
      : "Sub-category created successfully."),
  icon: "success",
  confirmButtonText: "OK",
  confirmButtonColor: "#214b7a",
  target: document.body,
  heightAuto: false,
  didOpen: () => {
    const popup = Swal.getPopup();
    if (popup) {
      popup.style.zIndex = "20000";
    }

    const container = Swal.getContainer();
    if (container) {
      container.style.zIndex = "20000";
    }
  },
});


      setModalOpen(false);
      setEditingItem(null);

      // Reload the list to display the latest API data.
      window.location.reload();
    } catch (error) {
      console.error("Sub-category submission failed:", error);

      showSwal(
        "Error!",
        error.message || "Something went wrong.",
        "error"
      );
    }
  },
  [editingItem, hasDuplicate, showSwal]
);


  const openModal = useCallback((item = null) => {
    if (!categories.length && !catLoading) {
      showSwal("Error!", "No categories available. Please create a category first.", "warning");
      return;
    }
    setEditingItem(item);
    setModalOpen(true);
  }, [categories, catLoading, showSwal]);

  const closeModal = useCallback(() => {
    setModalOpen(false);
    setEditingItem(null);
  }, []);

const handleDelete = useCallback(
  (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#214b7a", // 🔵 your HEX blue
      cancelButtonColor: "#6c757d",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteItem(id);
          showSwal("Deleted!", "The sub category has been deleted.", "success");
        } catch (error) {
          showSwal("Error!", error.message || "Delete failed.", "error");
        }
      }
    });
  },
  [deleteItem, showSwal]
);

  const handleToggleStatus = useCallback(
    async (item) => {
      try {
        const updatedData = {
          category_id: item.category_id,
          name: item.name,
          slug: item.slug,
          status: item.status ? 0 : 1,
        };
        await updateItem(item.id, updatedData);
        showSwal("Success!", "Sub-category status updated.", "success");
      } catch {
        showSwal("Error!", "Failed to update status.", "error");
      }
    },
    [updateItem, showSwal]
  );

  const tableData = useMemo(
    () =>
      subCategories.map((item, idx) => {
        const cat = categories.find((c) => c.id === item.category_id);
        return {
          ...item,
          sl: idx + 1,
          category_name: cat ? cat.name : "—",
        };
      }),
    [subCategories, categories]
  );

  return (
    <DashboardWrapper>

      <div className="container-fluid mt-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <button
            className="btn btn-secondary d-flex align-items-center"
            onClick={() => navigate(-1)}
          >

            <span>Back</span>
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => openModal()} 
                     style={{
    backgroundColor: "#214b7a",
    borderColor: "#214b7a",
    color: "#fff"
  }}
          >
            Create Sub Category
          </button>
        </div>

        <div className="card shadow">
                   <div className="card-header d-flex flex-wrap justify-content-between align-items-center gap-3">
       <h4 className="mb-0">Sub Categories</h4>

  <input
    type="text"
    className="form-control"
    placeholder="Search products..."
    value={searchText}
    onChange={(e) => setSearchText(e.target.value)}
    style={{
      width: "260px",
      maxWidth: "100%",
      borderRadius: "6px",
    }}
  />
</div>



          {modalOpen && (
            <div
              className="modal fade show"
              tabIndex={-1}
              style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
              aria-modal="true"
              role="dialog"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header d-flex justify-content-between align-items-center">
                    <h5 className="modal-title">
                      {editingItem ? "Edit Sub Category" : "Create Sub Category"}
                    </h5>
                    <button
                      type="button"
                      className="btn-close .btn-danger"
                      aria-label="Close"
                      onClick={closeModal}
                    />
                  </div>
                  <div className="modal-body">
                    {catLoading ? (
                      <div className="text-center p-4">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : (
                     <CrudForm
  initialData={getFormData(editingItem)}
  onSubmit={handleSubmit}
  allowedFields={allowedFields}
  categories={categories}
  fileFields={[
    {
      name: "sub_cat_image",
      multiple: false,
      required: false,
    },
  ]}
/>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {subLoading && !tableData.length ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: 200 }}
            >
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div className="card-body">
              <CrudTable
                data={tableData}
                onEdit={openModal}
                onDelete={handleDelete}
                onToggleStatus={handleToggleStatus}
                  searchText={searchText}
                columns={["sl", "id", "name", "category_name", "status"]}
              />
            </div>
          )}
        </div>
      </div>
    </DashboardWrapper>
  );
}